var React = require('react');

function Successful (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("circle",{"cx":"16.5","cy":"16","r":"16","fill":"#E7FFEF","key":0}),React.createElement("path",{"d":"M14.7241 21.0517C14.412 21.3562 13.9136 21.3546 13.6034 21.0483L9.08607 16.5871C8.76519 16.2702 8.76952 15.7509 9.09563 15.4394L9.87849 14.6916C10.1914 14.3927 10.6853 14.3968 10.9932 14.7009L13.6317 17.3066C13.9433 17.6143 14.4444 17.6143 14.756 17.3066L21.9975 10.1551C22.3091 9.8474 22.8102 9.84741 23.1218 10.1551L23.92 10.9435C24.2386 11.258 24.237 11.7728 23.9165 12.0854L14.7241 21.0517Z","fill":"#3BB75E","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"x":"0.5","width":"32","height":"32","fill":"white"})))]);
}

Successful.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = Successful;

Successful.default = Successful;
